(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-bar"]) return;
  try {
    
  (function () {
    function init(bar) {
      if (!bar || bar.dataset.bfInit === 'true') return;
      bar.dataset.bfInit = 'true';

      var raw = (bar.dataset.end || '').trim();
      // Formato esperado: AAAA-MM-DD HH:MM (horario de Brasilia, UTC-03:00)
      var iso = raw.replace(' ', 'T');
      if (iso.length === 16) iso += ':00';
      var endTime = new Date(iso + '-03:00').getTime();
      if (isNaN(endTime)) return;

      var hideWhenEnded = bar.dataset.hideWhenEnded === 'true';
      var els = {
        days: bar.querySelector('[data-unit="days"]'),
        hours: bar.querySelector('[data-unit="hours"]'),
        minutes: bar.querySelector('[data-unit="minutes"]'),
        seconds: bar.querySelector('[data-unit="seconds"]'),
      };
      var last = {};

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function set(key, value) {
        var text = pad(value);
        if (last[key] === text) return;
        last[key] = text;
        var el = els[key];
        if (!el) return;
        el.textContent = text;
        el.classList.remove('is-tick');
        void el.offsetWidth;
        el.classList.add('is-tick');
      }

      var timer;

      function update() {
        var diff = endTime - Date.now();
        if (diff <= 0) {
          set('days', 0);
          set('hours', 0);
          set('minutes', 0);
          set('seconds', 0);
          if (hideWhenEnded && !(window.Shopify && Shopify.designMode)) bar.hidden = true;
          clearInterval(timer);
          return;
        }
        var total = Math.floor(diff / 1000);
        set('days', Math.floor(total / 86400));
        set('hours', Math.floor((total % 86400) / 3600));
        set('minutes', Math.floor((total % 3600) / 60));
        set('seconds', total % 60);
      }

      update();
      timer = setInterval(update, 1000);
    }

    function initAll() {
      document.querySelectorAll('.bf-bar').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
